import {Vector3} from 'three';

import * as corgi from 'external/dev_april_corgi+/js/corgi';
import {ACTION} from 'external/dev_april_corgi+/js/emu/events';

import {Graph} from './execution/graph';

import {AddSubgraphController, State} from './add_subgraph_controller';
import {listGraphs} from './workspace_storage';
import {Button, Select} from './widgets';

export function makeAddSubgraphDialog({
  graph,
  position,
}: {
  graph: Graph;
  position: Vector3;
}) {
  return <AddSubgraphDialog graph={graph} position={position} />;
}

function AddSubgraphDialog(
  {graph, position}: {graph: Graph; position: Vector3},
  state: State | undefined,
  updateState: (newState: State) => void,
) {
  if (!state) {
    state = {
      graphs: listGraphs(),
    };
  }

  if (state.graphs.length === 0) {
    return (
      <div className="bg-neutral-800 max-h-[inherit] overflow-y-auto p-4 oy-4 rounded">
        <div>No saved graphs available to use as subgraphs.</div>
      </div>
    );
  }

  return (
    <div
      className="bg-neutral-800 max-h-[inherit] overflow-y-auto p-4 oy-4 rounded"
      js={corgi.bind({
        controller: AddSubgraphController,
        args: {graph, position},
        events: {corgi: [[ACTION, 'addSubgraph']]},
        state: [state, updateState],
      })}
    >
      <div>Select subgraph</div>
      <div>
        <Select
          ref="selection"
          options={state.graphs.map(g => ({label: g.name, value: g.id}))}
        />
      </div>
      <div className="flex justify-end">
        <Button buttonType="primary">Add</Button>
      </div>
    </div>
  );
}
